// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__2cwV7","container":"Cards_container__3Gs8x","infected":"Cards_infected__3Ki0i","recovered":"Cards_recovered__3V8jt","deaths":"Cards_deaths__oNNRm"};